var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicargoStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62109 22.0664V23.3555C4.62109 23.7112 4.90984 24 5.26562 24H20.7344C21.0902 24 21.3789 23.7112 21.3789 23.3555V22.0664H4.62109Z",
    fill: "#1D4650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2844 9.60461C17.2753 8.55273 17.6955 7.12316 17.4369 5.68199C17.063 3.59629 15.2034 2 12.9999 2C10.7711 2 8.93164 3.62293 8.56297 5.68199C8.30429 7.12316 8.72453 8.55273 9.71539 9.60461C10.3861 10.317 10.6345 11.2284 10.7247 11.8673C10.9142 13.211 10.5069 14.2263 9.99597 14.9766H16.0047C15.4934 14.2263 15.0861 13.2101 15.2751 11.8673C15.3653 11.2284 15.6137 10.317 16.2844 9.60461Z",
    fill: "#1D4650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0234 20.7773H3.97656C3.62061 20.7773 3.33203 20.4888 3.33203 20.1328V19.4883C3.33203 17.7113 4.77771 16.2656 6.55469 16.2656H19.4453C21.2223 16.2656 22.668 17.7113 22.668 19.4883V20.1328C22.668 20.4888 22.3794 20.7773 22.0234 20.7773Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicargoStamp);
export default __webpack_public_path__ + "static/media/unicargo-stamp.fc339c629a96ec930808b05444543724.svg";
export { ForwardRef as ReactComponent };